import React from 'react';
import { useApp } from '../context/AppContext';

/**
 * CartIcon — floating action button at bottom-right.
 * Shows item count badge.
 */
export default function CartIcon({ onClick }) {
  const { cartCount, cartTotal } = useApp();

  if (cartCount === 0) return null;

  return (
    <button
      style={styles.fab}
      onClick={onClick}
      aria-label={`Cart: ${cartCount} items`}
    >
      <span style={styles.icon}>🛒</span>
      <span style={styles.info}>
        <span style={styles.count}>{cartCount}</span>
        <span style={styles.dot}>•</span>
        <span style={styles.total}>{cartTotal} DH</span>
      </span>
      {/* Pulsing badge */}
      <span style={styles.badge}>{cartCount}</span>
    </button>
  );
}

const styles = {
  fab: {
    position: 'fixed',
    bottom: '1.5rem',
    right: '50%',
    transform: 'translateX(50%)',
    zIndex: 150,
    display: 'flex',
    alignItems: 'center',
    gap: '0.6rem',
    padding: '0.85rem 1.5rem',
    backgroundColor: 'var(--accent)',
    color: 'var(--text-inverse)',
    borderRadius: 'var(--radius-full)',
    boxShadow: '0 6px 24px var(--accent-glow), 0 2px 8px rgba(0,0,0,0.15)',
    transition: 'all var(--transition)',
    animation: 'fadeInUp 0.3s ease',
    maxWidth: '480px',
    width: 'calc(100% - 2rem)',
    justifyContent: 'center',
  },
  icon: {
    fontSize: '1.15rem',
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.4rem',
    fontWeight: 600,
    fontSize: '0.95rem',
  },
  count: {
    fontWeight: 700,
  },
  dot: {
    opacity: 0.5,
    fontSize: '0.6rem',
  },
  total: {
    fontWeight: 600,
  },
  badge: {
    display: 'none', // Hidden since we show inline count
  },
};
